import {Info} from 'lucide-react'
import React from 'react'

type AttendanceV2NoDataNoticeProps = {
  title: string
  names: string[]
  theme: 'light' | 'dark'
}

/** The requested items the backend had no records for (`data.stats.noDataFor`), listed apart from
 *  the rows it did find so a partial answer reads as partial rather than as the whole picture. Only
 *  rendered when at least one name survives trimming. */
const AttendanceV2NoDataNotice: React.FC<AttendanceV2NoDataNoticeProps> = ({
  title,
  names,
  theme,
}) => {
  const cleaned = names.map((name) => name?.trim()).filter((name): name is string => Boolean(name))
  if (!cleaned.length) return null

  const borderColor = theme === 'dark' ? 'rgba(255,255,255,0.18)' : 'rgba(0,0,0,0.1)'
  const cardBg = theme === 'dark' ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'
  const textColor = theme === 'dark' ? 'rgba(255,255,255,0.8)' : '#6c757d'
  const chipBorder = theme === 'dark' ? 'rgba(255,255,255,0.16)' : 'rgba(0,0,0,0.12)'
  const chipBg = theme === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.04)'

  return (
    <div
      className='rounded-2 p-2 mt-2'
      style={{border: `1px solid ${borderColor}`, backgroundColor: cardBg, color: textColor}}
    >
      <div
        className='d-flex align-items-center gap-2 mb-1'
        style={{fontSize: '0.8rem', fontWeight: 600}}
      >
        <Info size={14} style={{flexShrink: 0}} aria-hidden='true' />
        <span>{title}</span>
      </div>
      <div className='d-flex flex-wrap gap-1'>
        {cleaned.map((name, index) => (
          <span
            key={`${name}-${index}`}
            className='rounded-pill px-2 py-1'
            style={{
              fontSize: '0.7rem',
              fontWeight: 500,
              border: `1px solid ${chipBorder}`,
              backgroundColor: chipBg,
            }}
          >
            {name}
          </span>
        ))}
      </div>
    </div>
  )
}

export default AttendanceV2NoDataNotice
